import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Input } from '../components/ui/Input'
import { Button } from '../components/ui/Button'
import { api } from '../lib/api'

export default function AdminLogin() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)

    try {
      const result = await api.adminLogin(password)
      if (result.success && result.token) {
        // Store token in localStorage
        localStorage.setItem('admin_token', result.token)
        // Redirect to admin dashboard
        navigate('/admin/orders')
      } else {
        setError('Invalid password')
      }
    } catch (err: any) {
      setError(err.message || 'Login failed. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              BPAC Elves' Workshop
            </h1>
            <h2 className="text-xl text-gray-700">Admin Login</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label="Password"
              type="password"
              placeholder="Enter admin password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={error || undefined}
              required
              autoFocus
            />

            <Button
              type="submit"
              fullWidth
              size="lg"
              disabled={isLoading || !password}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <a
              href="/"
              className="text-sm text-gray-600 hover:text-gray-800"
            >
              Back to Order Page
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
